export default __webpack_public_path__ + "static/media/Db6.9fde5269.mp3";